export default {
    state: {
        groups: [
            
        ]
    },
    actions: {

    },
    mutations: {
        addGroup(state, payload){
            state.groups.push(payload);
        },
        removeGroup(state, index){
            state.groups.splice(index, 1);
        },
        addExercise(state, payload){

            state.groups[payload.g].exercises.push({
                id: payload.e['id'],
                name: payload.e['name'],
                type: payload.e.type,
                sets: [{reps: null}]
            });
        },
        addSet(state, payload){
            state.groups[payload.g].exercises[payload.e].sets.push({reps:null, weight: null});
        },
        removeSet(state, payload){
            state.groups[payload.g].exercises[payload.e].sets.splice(payload.s, 1);
        }
    },
    getters: {

    }
}